// extracted by mini-css-extract-plugin
export default {"review":"Review_review__NN0eE","img":"Review_img__hcE0j","name":"Review_name__j5IsG","comment":"Review_comment__KhiAn"};